import React, { useEffect } from "react";
import "./App.css";
import { getApp } from "./utils/helpers";
import ReactGA from "react-ga4";
import { useLocation } from "react-router-dom";

const App: React.FC = () => {
  const CurrentApp = getApp();
  const location = useLocation();

  // Initialize Google Analytics
  useEffect(() => {
    if(process.env.REACT_APP_STAGE === 'prod') {
      ReactGA.initialize("G-PPQC4M8NDH"); // Replace with your Google Analytics Measurement ID
    }
  }, []);

  // Track page views
  useEffect(() => {
    if(process.env.REACT_APP_STAGE === 'prod') {
      ReactGA.send({ hitType: "pageview", page: location.pathname });
    }
  }, [location]);

  return (
      <>
        <div>
          <div>
            <CurrentApp />
          </div>
        </div>
      </>
  );
};

export default App;

const styles = {
  root: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
  },
  padding: {
    paddingLeft: 60,
    paddingTop: 6,
  },
} as const;